import React, { Component } from "react";
import { Icon } from "antd";
import PropTypes from 'prop-types';
import DateSelectorComponent from './DateSelector';
import moment from "moment";
import { InfoContentWrapper, InfoWrapper, DisplayFlexOkay, PrimaryButtonOkay, PopHeader, QASectionWrapper, IconWrap } from './styles';

let currentDates = [];
let cDate = moment();
let bDate = moment().subtract(30, 'd');
let todayDate = moment(cDate).format('DD/MM/YYYY');
let beforeMonth = moment(bDate).format('DD/MM/YYYY');
currentDates[0] = moment(cDate).format('YYYY-MM-DD');
currentDates[1] = moment(bDate).format('YYYY-MM-DD');
class Calendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      dates: "",
      calendarEndDate: this.props.filterMaxDate
    };
    this.toTimeFrame = this.toTimeFrame.bind(this);
    this.disabledEndDate = this.disabledEndDate.bind(this);
    this.startDate = this.startDate.bind(this);
    this.endDate = this.endDate.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible) {
      currentDates[0] = moment(cDate).format('YYYY-MM-DD');
      currentDates[1] = moment(bDate).format('YYYY-MM-DD');
    }
  }
  handleOk = e => {
    this.setState({
      visible: false
    });
  };

  disabledEndDate(current) {
    // Can not select days before today and today
    return current && current > moment().endOf('day');
  }

  toTimeFrame = (dates) => {
    if (!dates) {
      this.setState({ dates: "" });
    }
    else {
      currentDates = dates.dateString;
      this.setState({ dates: moment(dates.dateString).format("MM/DD/YYYY") });
    }
  }

  startDate = (dates) => {
    currentDates[0] = dates;
  }
  endDate = (dates) => {
    currentDates[1] = dates;
    this.setState({ calendarEndDate: dates })
  }


  render() {
    return (
      <div className={(!this.props.visible && 'hidden')} data-test="transaction-calender">
        <InfoWrapper>
          <InfoContentWrapper>
            <IconWrap>
              <Icon type="close" onClick={this.props.onCancel} />
            </IconWrap>
            <PopHeader>
              Pick Time Frame
            </PopHeader>
            <div>
              <QASectionWrapper>
                <DateSelectorComponent
                  startDate={this.startDate}
                  endDate={this.endDate}
                  open={this.props.visible}
                  calendarEndDate={this.state.calendarEndDate}
                  defaultValue={[moment(beforeMonth, 'DD/MM/YYYY'), moment(todayDate, 'DD/MM/YYYY')]}
                  dateValues={this.props.dateValues}
                  toTimeFrame={this.toTimeFrame}
                />
              </QASectionWrapper>
              <DisplayFlexOkay>
                <PrimaryButtonOkay
                  onClick={() => { this.props.onFilterClick(currentDates) }} >
                  Filter
              </PrimaryButtonOkay>
              </DisplayFlexOkay>
            </div>
          </InfoContentWrapper>
        </InfoWrapper>
      </div>
    );
  }
}

Calendar.propTypes = {
  filterMaxDate: PropTypes.string,
  filterMinDate: PropTypes.string,
  visible: PropTypes.bool,
  endDate: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onFilterClick: PropTypes.func.isRequired,
  startDate: PropTypes.func.isRequired
}

export default Calendar;
